// extracted by mini-css-extract-plugin
export default {"contact":"Contact_contact__K3j9k","btn":"Contact_btn__Bqyvz"};